"use client";

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { selectTextField } from "./5VQZOHHZ.js";
import { useCompositeContext } from "./P7GR5CS5.js";
import { createElement, createHook, forwardRef } from "./LMDWO4NN.js";
import { useStoreState } from "./YV4JVR4I.js";
import { useEvent, useMergeRefs } from "./ABQUS43J.js";
import { __objRest, __spreadProps, __spreadValues } from "./3YLGPPWQ.js";

// src/composite/composite-container.tsx
import { isButton, isTextField } from "@ariakit/core/utils/dom";
import { isFocusEventOutside, isSelfTarget } from "@ariakit/core/utils/events";
import { disableFocusIn, getFirstTabbableIn, restoreFocusIn } from "@ariakit/core/utils/focus";
import { removeUndefinedValues } from "@ariakit/core/utils/misc";
import { useEffect, useRef } from "react";
var TagName = "div";
function getFirstTabbable(container) {
  restoreFocusIn(container);
  var tabbable = getFirstTabbableIn(container);
  disableFocusIn(container);
  return tabbable;
}
var useCompositeContainer = createHook(function useCompositeContainer2(_a) {
  var _b = _a,
    store = _b.store,
    props = __objRest(_b, ["store"]);
  var context = useCompositeContext();
  store = store || context;
  var ref = useRef(null);
  var isOpenRef = useRef(false);
  var open = function open() {
    var collapseToEnd = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var container = ref.current;
    if (!container) return;
    restoreFocusIn(container);
    var tabbable = getFirstTabbableIn(container);
    if (!tabbable) {
      disableFocusIn(container);
      return;
    }
    isOpenRef.current = true;
    queueMicrotask(function () {
      tabbable.focus();
      if (isTextField(tabbable) || tabbable.isContentEditable) {
        selectTextField(tabbable, collapseToEnd);
      }
    });
  };
  var close = function close() {
    var container = ref.current;
    if (!container) return;
    isOpenRef.current = false;
    disableFocusIn(container);
  };
  var renderedItems = useStoreState(store, "renderedItems");
  useEffect(function () {
    var container = ref.current;
    if (!container) return;
    var isOpen = isOpenRef.current;
    if (!isOpen && (renderedItems == null ? void 0 : renderedItems.length)) {
      disableFocusIn(container);
    }
  }, [renderedItems]);
  var onFocusProp = props.onFocus;
  var onFocus = useEvent(function (event) {
    onFocusProp == null ? void 0 : onFocusProp(event);
    if (event.defaultPrevented) return;
    if (!store) return;
    var isOpen = isOpenRef.current;
    if (isSelfTarget(event)) {
      isOpenRef.current = false;
      var _store$getState = store.getState(),
        baseElement = _store$getState.baseElement;
      var composite = baseElement;
      var selector = "[data-composite-container]";
      var containers = composite == null ? void 0 : composite.querySelectorAll(selector);
      if (containers) {
        var _iterator = _createForOfIteratorHelper(containers),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var container = _step.value;
            disableFocusIn(container);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    } else if (!isOpen) {
      isOpenRef.current = true;
      restoreFocusIn(event.currentTarget);
      store == null ? void 0 : store.setState("moves", 0);
    }
  });
  var onBlurProp = props.onBlur;
  var onBlur = useEvent(function (event) {
    onBlurProp == null ? void 0 : onBlurProp(event);
    if (event.defaultPrevented) return;
    if (isFocusEventOutside(event)) {
      close();
    }
  });
  var onKeyDownProp = props.onKeyDown;
  var onKeyDown = useEvent(function (event) {
    onKeyDownProp == null ? void 0 : onKeyDownProp(event);
    if (event.defaultPrevented) return;
    if (event.altKey) return;
    if (event.ctrlKey) return;
    if (event.metaKey) return;
    if (event.shiftKey) return;
    var container = event.currentTarget;
    if (isSelfTarget(event)) {
      if (event.key.length === 1 && event.key !== " ") {
        var tabbable = getFirstTabbable(container);
        if (!tabbable) return;
        if (isTextField(tabbable) || tabbable.isContentEditable) {
          event.stopPropagation();
          open();
        }
      } else if (event.key === "Delete" || event.key === "Backspace") {
        var _tabbable = getFirstTabbable(container);
        if (!_tabbable) return;
        if (isTextField(_tabbable) || _tabbable.isContentEditable) {
          open();
          var onInput = function onInput() {
            return queueMicrotask(function () {
              return container.focus();
            });
          };
          container.addEventListener("input", onInput, {
            once: true
          });
        }
      }
    } else if (event.key === "Escape") {
      queueMicrotask(function () {
        return container.focus();
      });
    } else if (event.key === "Enter") {
      var target = event.target;
      var isInput = target.tagName === "INPUT" && !isButton(target) || target.tagName === "TEXTAREA";
      if (isInput || target.isContentEditable) {
        event.preventDefault();
        queueMicrotask(function () {
          return container.focus();
        });
      }
    }
  });
  var onClickProp = props.onClick;
  var onClick = useEvent(function (event) {
    onClickProp == null ? void 0 : onClickProp(event);
    if (event.defaultPrevented) return;
    if (isSelfTarget(event) && !event.detail) {
      open(true);
    }
  });
  props = __spreadProps(__spreadValues({
    "data-composite-container": ""
  }, props), {
    ref: useMergeRefs(ref, props.ref),
    onFocus: onFocus,
    onBlur: onBlur,
    onKeyDown: onKeyDown,
    onClick: onClick
  });
  return removeUndefinedValues(props);
});
var CompositeContainer = forwardRef(function CompositeContainer2(props) {
  var htmlProps = useCompositeContainer(props);
  return createElement(TagName, htmlProps);
});
export { useCompositeContainer, CompositeContainer };